import React from 'react';
import PropTypes from 'prop-types';

import AnnouncementModal from '../index';
import dataModel from '../../../../models/DataModel';
import MobileFilesIcon from '../../../../assets/images/mobile-files.svg';
import FlipButton from '../../../Buttons/FlipButton';

import './MobileFilesAnnouncementModal.scss';

/**
 * MobileFilesAnnouncementModal is a <GlobalModal> which is used to display an initial
 * fullscreen mobile files announcement/overlay to the user. Users should only see this once.
 */
export default class MobileFilesAnnouncementModal extends React.Component {

  constructor(props) {
    super(props);
    MobileFilesAnnouncementModal.propTypes = {
      /** onClose - Function called by the parent when the modal is closed */
      onClose: PropTypes.func,
    };

    this.state = {
      /** setting a value triggers a fade out/close - possible values: 'slow', 'quick' */
      fade: null,
    };

    this.close = this.close.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSlowFade = this.handleSlowFade.bind(this);
  }

  handleSlowFade() {
    this.setState({ fade: 'slow' });
  }

  handleClose() {
    this.setState({ fade: 'quick' });
  }

  /**
   * Function called when the popup is closed. Also calls onClose() in the parent.
   */
  close() {
    if (this.props.onClose) {
      this.props.onClose();
    }
    dataModel.hideGlobalModal();
  }

  render() {
    let modalClassName = 'mobile-files-announcement';

    const fade = this.state.fade;
    if (fade == 'quick') {
      modalClassName += ' mobile-files-announcement--quick-fade';
      setTimeout(this.close, 500);
    }
    else if (fade == 'slow') {
      modalClassName += ' mobile-files-announcement--slow-fade';
      setTimeout(this.close, 2000);
    }

    return (
      <div className={modalClassName}>
        <AnnouncementModal
          headingText='Introducing'
          subHeadingText='Mobile File Uploads'
          bodyText='Upload any document right from your mobile device!'
          onClose={this.handleClose}
        >
        <img className="mobile-files-announcement__img" src={MobileFilesIcon} alt='mobile-files'/>
        <FlipButton
          handleClick={this.handleSlowFade}
          frontText={'GOT IT'}
          backText={'Thanks!'}
        />
        </AnnouncementModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AnnouncementModal/MobileFilesAnnouncementModal/index.js